/** @format */

import React, { useState } from "react";
import cn from "classnames";
import moment from "moment/moment";
import { isMobile } from "react-device-detect";
import style from "./style.module.scss";
import CustomDatePicker from "../../shared/date-picker/Date";
import CustomDateTime from "../../shared/date-picker/Time";
import CalendarIcon from "../../shared/icons/CalendarIcon";
import ArrowDownIcon from "../../shared/icons/ArrowDownIcon";

const OrdersDatePickerTender = ({
  date,
  timeEnd,
  isEditable = false,
  isSender = false,
  minDate,
  setDate,
  setTimeEnd,
  detect,
  labelText = "",
  labelTimeEnd = "",
  errorDate = "",
  errortimeEnd = "",
  placeholderText = "00.00.00",
  isReadOnly = false,
}) => {
  const [openPicker, setOpenPicker] = useState(null);
  const prefixTimeType = isSender ? "погрузки" : "выгрузки";

  const handleFieldClick = (type, event) => {
    if (!isEditable || isReadOnly || event.target.closest(".react-datepicker")) return;
    setOpenPicker(type);
  };

  const setPlaceholderTime = (time) => {
    return time ? moment(time).format("HH:mm") : "__:__";
  };

  const filterPassedTime = (time) => {
    const selectedDate = new Date(time);
    return new Date().getTime() < selectedDate.getTime();
  };

  const onChangeDate = (date) => {
    const dateWithZeroTime = new Date(date);
    dateWithZeroTime.setHours(0, 0, 0, 0);

    setDate(dateWithZeroTime);
    if (!timeEnd) {
      setTimeEnd(new Date(date.setHours(18)));
    }
    if (detect) detect();
    setOpenPicker(null);
  };

  const onChangeTimeEnd = (time) => {
    setTimeEnd(time);
    setOpenPicker(null);
  };

  const ContentItemEditable = (type) => {
    if (type === "date") {
      return (
        <CustomDatePicker
          selected={date}
          dateFormat="dd.MM.yyyy"
          placeholderText={placeholderText}
          monthsShown={1}
          minDate={minDate}
          onChange={onChangeDate}
          open={openPicker === "date"}
          onClickOutside={() => setOpenPicker(null)}
          withPortal={isMobile}
          disabled={isReadOnly}
        />
      );
    } else if (type === "time-before") {
      return (
        <CustomDateTime
          selected={timeEnd}
          showTimeSelect
          filterTime={filterPassedTime}
          timeCaption={`Время ${prefixTimeType} до ${setPlaceholderTime(timeEnd)}`}
          onChange={onChangeTimeEnd}
          open={openPicker === "time-before"}
          onClickOutside={() => setOpenPicker(null)}
          disabled={isReadOnly}
        />
      );
    }

    return null;
  };

  return (
    <>
      <div>
        <div
          className={cn("d-flex align-items-center justify-content-between", {
            [style.editable]: isEditable,
            [style.errorState]: errorDate,
          })}
          onClick={(event) => handleFieldClick("date", event)}
        >
          <div
            className={cn(style.labelInp, { [style.labelError]: errorDate })}
          >
            {labelText}
          </div>
          {isEditable ? ContentItemEditable("date") : ContentItem("date", date)}
          <CalendarIcon />
        </div>
        {errorDate && <div className={style.errorText}>{errorDate}</div>}
      </div>

      <div className={cn(style.wrapper_time)}>
        <div>
          <div
            className={cn("d-flex align-items-center", {
              [style.editable]: isEditable,
              [style.errorState]: errortimeEnd,
            })}
            onClick={(event) => handleFieldClick("time-before", event)}
          >
            <div
              className={cn(style.labelInp, {
                [style.labelError]: errortimeEnd,
              })}
            >
              {labelTimeEnd}
            </div>
            {isEditable
              ? ContentItemEditable("time-before")
              : ContentItem("time", timeEnd, "до ")}
            <ArrowDownIcon stroke="#6D7885" width="20px" height="20px" />
          </div>
          {errortimeEnd && (
            <div className={style.errorText}>{errortimeEnd}</div>
          )}
        </div>
      </div>
    </>
  );
};

const ContentItem = (type = "", value, prefixStart = "") => {
  let text = "";

  if (type === "date") {
    text = moment.utc(value).format("DD.MM.YYYY");
  } else if (type === "time") {
    text = moment.utc(value).format("HH:mm");
  }

  return (
    <span className="ms-1">
      {prefixStart}
      {text}
    </span>
  );
};

export default OrdersDatePickerTender;
